module.exports = __webpack_public_path__ + "img/9-mob.49e1bf2e.svg";